import { Component, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MDTagComponent } from '@melodic-ui/components';
import { RouterModule, UrlTree } from '@angular/router';

export type TabItem = {
	linkText: string;
	routerLink?: string | UrlTree;
	tagValue?: string;
	/** When true, the tab is only marked active on an exact URL match (use for base/parent paths). */
	exactMatch?: boolean;
};

@Component({
	selector: 'lb-navigation-tab-group',
	standalone: true,
	imports: [CommonModule, RouterModule, MDTagComponent],
	templateUrl: './navigation-tab-group.component.html',
	styleUrl: './navigation-tab-group.component.scss'
})
export class NavigationTabGroupComponent {
	public tabList: InputSignal<TabItem[]> = input<TabItem[]>([]);
	public orientation: InputSignal<'horizontal' | 'vertical'> = input<'horizontal' | 'vertical'>('vertical');
}
